import { createSelector } from 'reselect';

const userSelector = ({userReducer}) => userReducer;

export const getPermissions = createSelector(
  userSelector,
  ({userAbilitiesReducer}) => userAbilitiesReducer.permissions
);

export const getUserstore = createSelector(
  userSelector,
  ({ userstore }) => userstore
);
